<template>
    <div>

        <div class="row">
            <div class="col-xs-12 col-md-6">
                <div class="form-group mb-2">
                    <label class="col-form-label" for="toll_product">
                        {{ $t('shop.route') }}
                    </label>
                    <select
                        name="product_id"
                        id="toll_product"
                        class="form-control"
                        ref="routeTollProduct"
                        @change="
                            $emit('route-selected', selectedRoute);
                        "
                        :class="{ 'is-invalid': formErrors.product_id }"
                        v-model="selectedRoute"
                        required
                    >
                        <option disabled value="0" v-if="defaultSelectedOption === 0" selected>
                            {{ $t('shop.dropdown_required') }}
                        </option>
                        <option
                            :value="tollProduct.id"
                            :key="tollProduct.id"
                            v-for="tollProduct in tollProducts"
                        >
                            {{ tollProduct.name }}
                        </option>
                    </select>
                    <div class="invalid-feedback">
                    <span class="d-block" v-for="error in formErrors.product_id" :key="error">
                        {{ error}}
                    </span>
                    </div>
                </div>
            </div>
            <div class="col-xs-12 col-md-6" v-if="selectedRoute !== null">
                <div class="form-group mb-2">
                    <label class="col-form-label" for="toll_option">
                        {{ $t('shop.option') }}
                    </label>
                    <select
                        name="option_id"
                        id="toll_option"
                        class="form-control"
                        ref="routeTollOptions"
                        required
                        :class="{ 'is-invalid': formErrors.option_id }"
                        v-model="selectedTollOption"
                        @change="$emit('option-selected', selectedTollOption);"
                    >
                        <option disabled value="0" selected>{{ $t('shop.dropdown_required') }}</option>
                        <option
                            :value="option.id"
                            :key="option.id"
                            v-for="option in options"
                            :price="option.price.toFixed(2)"
                            :service-fee="option.service_fee.toFixed(2)"
                        >
                            {{ option.name }}
                        </option>
                    </select>
                    <div class="invalid-feedback">
                    <span class="d-block" v-for="error in formErrors.option_id" :key="error">
                        {{ error }}
                    </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div
                v-if="
                selectedRoute &&
                typeof tollProducts[selectedRoute].info === 'string' &&
                tollProducts[selectedRoute].info.trim().length > 0
            "
                class="col-12"
            >
                <div class="row align-items-center mb-2 bg-light rounded px-0 p-5 border-primary">
                    <div class="col-md-2">
                        <i class="mdi mdi-exclamation status-icon status-icon-warning"></i>
                    </div>
                    <div class="col-md-10">
                        <h4
                            class="mb-0 mb-mobile mobile-text-center"
                            v-html="$t('shop.attention_route_toll')"
                        ></h4>
                        <span class="text-quote mobile-text-center">
                        <p v-html="tollProducts[selectedRoute].info"></p>
                    </span>
                    </div>
                </div>
            </div>

            <div
                class="col-12"
                v-if="
                selectedTollOption &&
                options[selectedTollOption].is_validity_controllable
            "
            >
                <div class="form-group mb-2">
                    <label class="col-form-label" for="valid_from">
                        {{ $t('shop.validity_start') }}
                    </label>
                    <DatePicker
                        id="valid_from"
                        name="validity_start"
                        required="required"
                        :config="datePickerOptions"
                        @dp-change="
                            $emit('validity-start-change', routeTollValidityStart);
                            $emit('display-route-toll-validity-range');
                            $emit('input-change', 'validity_start');
                        "
                        v-model="routeTollValidityStart"
                        :class="{ 'is-invalid': formErrors.validity_start }"
                        :disable-placeholder="setVignetteValidFromNullSetting"
                    >
                    </DatePicker>
                    <div class="invalid-feedback">
                        <div v-if="formErrors.validity_start && !vignetteValidFrom">
                            {{ $t('shop.validity_from_input_empty_error') }}
                        </div>
                        <div v-else>
                            <span class="d-block" v-for="error in formErrors.validity_start" :key="error">
                                {{ error }}
                            </span>
                        </div>
                    </div>
                    <div class="invalid-validity-start" v-if="validFromNotice">
                        <span class="d-block" v-html="validFromNotice"></span>
                    </div>
                    <span
                        v-if="validToDate"
                        class="d-block mt-2 mt-0 h5 bg-light rounded py-2 text-center"
                    >{{ $t('shop.validity_end') }} {{ validToDate }}</span
                    >
                </div>
            </div>
            <div class="col-12 text-center" v-else-if="routeTollValidityStart">
                <div class="route-toll-valid-from mt-0 h5 bg-light rounded py-2">
                    <span class="prefix-label">{{ $t('shop.validity_start') }}</span>
                    <span class="to-date-label">{{ routeTollValidityStart.date }}</span>
                    <span class="to-time-label">{{ routeTollValidityStart.time }}</span>
                    <template v-if="validToDate && Object.keys(validToDate).length > 0">
                        -
                        <span class="to-date-label">
                        {{ validToDate.date }}
                    </span>
                    </template>
                </div>
            </div>
            <div
                class="col-12 text-center"
                v-if="
                selectedTollOption &&
                options[selectedTollOption].is_validity_controllable
            "
            >
                <div
                    class="mb-0 p-4 row align-items-center bg-light rounded px-0 vehicle-info-box border-primary w-100"
                >
                    <div class="col-md-2">
                        <i class="mdi mdi-information-variant status-icon status-icon-warning"></i>
                    </div>
                    <div class="col-md-10">
                    <span
                        class="text-quote mobile-text-center"
                        v-html="$t('shop.route_toll_price_info')"
                    ></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DatePicker from '../../DatePicker.vue';

export default {
    name: 'RouteTollOption',
    components: { DatePicker },

    props: [
        'datePickerOptions',
        'formErrors',
        'validFromNotice',
        'validTo',
        'validFrom',
        'options',
        'selectedOption',
        'defaultSelectedOption',
        'tollProducts',
        'setValidFromNull',
    ],

    data() {
        return {
            selectedRoute: this.defaultSelectedOption,
            selectedTollOption: 0,
            routeTollValidityStart: this.setValidFromNull ? null : this.validFrom,
            setVignetteValidFromNullSetting: this.setValidFromNull,
            validToDate: this.setValidFromNull ? null : this.validTo,
        };
    },

    watch: {
        routeTollValidityStart() {
            if (this.setVignetteValidFromNullSetting && this.selectedRoute[this.selectedTollOption].is_validity_controllable) {
                this.routeTollValidityStart = null;
                this.validToDate = null;
            }

            this.formErrors.validity_start = null;
        },

        validTo() {
            this.validToDate = this.validTo;
        },
    },
};
</script>
